module.exports = __webpack_public_path__ + "img/gb9115_28_d.prt.156dd044.jpg";